import * as Sentry from '@sentry/browser';
import posthog from 'posthog-js';
import {
  capturarErro,
  capturarErroAjax,
  filtrarEvento,
  registrarBreadcrumb,
  sanearBreadcrumb,
  sanearEvento,
} from '~/src/services/monitoramento';

try {
  const context = JSON.parse(document.getElementById('sentry_contexts').textContent);
  try {
    Sentry.init({
      dsn: __RAVEN_PUBLIC_DSN__,
      allowUrls: [window.location.origin],
      environment: context.reportable_context?.environment,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        /Non-Error promise rejection captured with value: (cancel|overlay)/,
      ],
      integrations: [posthog.sentryIntegration({
        organization: __ORGANIZATION_NAME_SENTRY__,
        projectId: __COMPANY_ID_SENTRY__,
        severityAllowList: ['error', 'info']
      })],
      beforeSend(event, hint) {
        return filtrarEvento(event, hint);
      },
      beforeBreadcrumb: (breadcrumb) => sanearBreadcrumb(breadcrumb),
    });

    Sentry.setUser(context.reportable_user_context);
    Sentry.setTags(context.reportable_context);

    window.MainoMonitoramento = { capturarErro, capturarErroAjax, registrarBreadcrumb };
  } catch (error) {
    console.error('Error initializing Sentry:', error);
  }
} catch (error) {
  console.error('Error parsing Sentry contexts:', error);
}
